module.exports = __webpack_public_path__ + "media/images/logos/logo-eon-e4ea06e155863e59b42f3b993cfc672f.svg";